module.exports = __webpack_public_path__ + "static/media/renovation & construction.8322afdf.png";